import actionTypes from 'constants/actionTypes'

type KindStyles = Record<string, unknown>


export const createOneKind = ({ id, label, styles }: { id: string; label: string; styles: KindStyles }, notify = false) => {
  return {
    type: actionTypes.KINDS.ONE.CREATE,
    payload: {
      id,
      label,
      styles
    },
    meta: {
      retry: true,
      request: 'kinds.create',
      notify
    }
  }
}

export const editOneKind = ({ id, label, styles }: { id: string; label: string; styles: KindStyles }, notify = false) => {
  return {
    type: actionTypes.KINDS.ONE.EDIT,
    payload: {
      id,
      label,
      styles
    },
    meta: {
      retry: true,
      request: 'kinds.edit',
      notify
    }
  }
}

export const deleteOneKind = ({ id }: { id: string }, notify = false) => {
  return {
    type: actionTypes.KINDS.ONE.DELETE,
    payload: { id },
    meta: {
      retry: true,
      request: 'kinds.delete',
      notify
    }
  }
}
